import { get as getPipe } from '../utils/sigpipe'
// import { create as createPipe } from '../utils/sigpipe'

import { ACTIONS as MODAL_ACTIONS } from './modal'

import Swiper from 'swiper/dist/js/swiper.min.js'

/**
 * Mock feature implementing most of the stuff on the stack.
 * Due to the 'withResponsive' HOC, foo will only mount on the requested breakpoints.
 *
 * Props:
 * shouldBar(boolean, optional): flag for toggling Bar
 * screens(object, optional): Used by withResponsive. object that can contains a 'min' and a 'max'
 * attribute. The breakpoints are specified in the withResponsive HOC.
 */
export default {
  name: 'modal-member-subscription',
  nbStep: 3,
  noAnswer: [],

  ui: {
    'yesBtn[]': '[js-button-step-yes]',
    'noBtn[]': '[js-button-step-no]',
    'btPartners[]': '[js-lets-be-partners]',
  },

  events: [
    {
      target: 'noBtn',
      on: 'click',
      handle (e) {
        console.log('no')
        const index = e.currentTarget.getAttribute('js-button-step-no')
        this.noAnswer.push(index)
        this.subsciptionKOlist.innerHTML += `<li class="uppon-title uppon-title--XS uppon-title--grey-darker">«${
          this.innerSwiper.slides[index - 1].querySelector('.question')
            .innerText
        }»</li>`
        this.progress(index)
        this.innerSwiper.slideNext()
      },
    },

    {
      target: 'yesBtn',
      on: 'click',
      handle (e) {
        this.progress(e.currentTarget.getAttribute('js-button-step-yes'))
        this.innerSwiper.slideNext()
      },
    },
    {
      target: 'btPartners',
      on: 'click',
      handle (e) {
        const value = e.currentTarget.getAttribute('js-lets-be-partners')
        if (value === 'yes') {
          this.mainSwiper.slideTo(3)
        } else {
          this.el.querySelector('.patrner-req').classList.add('hidden')
          this.el.querySelector('.patrner-req').classList.remove('flex')
          this.el.querySelector('.card__wrapper').classList.remove('hidden')
        }
      },
    },
  ],

  componentDidMount () {
    this.subsciptionKOlist = this.el.querySelector('.subscription--KO ul')
    this.subsciptionKOlist.innerHTML = ''
    this.progressBar = this.el.querySelector('.progress__bar')

    setTimeout(() => {
      this.mainSwiper = new Swiper(this.el.querySelector('.main-swiper'), {
        // Optional parameters
        direction: 'horizontal',
        speed: 300,
        slidesPerView: 1,
        spaceBetween: 0,
        simulateTouch: false,
        shortSwipes: false,
        longSwipes: false,
        allowTouchMove: false,
        // autoHeight: true
      })
    }, 400)

    setTimeout(() => {
      // this.mainSwiper.slideTo(2)
      this.innerSwiper = new Swiper(this.el.querySelector('.inner-swiper'), {
        // Optional parameters
        direction: 'horizontal',
        speed: 300,
        slidesPerView: 1,
        spaceBetween: 0,
        simulateTouch: false,
        shortSwipes: false,
        longSwipes: false,
        allowTouchMove: false,
        nested: true,
        // autoHeight: true
      })

      this.nbStep = this.innerSwiper.slides.length - 1
    }, 200)

    this.pipe = getPipe(this.el.getAttribute('data-pipe-id'))
    this.pipe.on(({ action, emitterEl }) => {
      this.emitterEl = emitterEl
      console.log(action)
      switch (action) {
        case MODAL_ACTIONS.OPEN:
          break

        case MODAL_ACTIONS.CLOSE:
          this.reInit()
          break
      }
    })

    // this.progress(0)
  },

  progress (index) {
    const percent = ((parseInt(index) + 0) * 100) / this.nbStep

    if (percent <= 100) this.progressBar.style.width = `${percent}%`
    this.getTunelResult(percent)
  },

  getTunelResult (percent) {
    if (percent > 100) {
      if (this.noAnswer.length > 0) {
        // KO
        this.mainSwiper.slideTo(2)
      } else {
        // OK
        this.mainSwiper.slideTo(1)
      }
    }
  },

  reInit () {
    if (this.mainSwiper) {
      setTimeout(() => {
        this.mainSwiper.slideTo(0)
        this.innerSwiper.slideTo(0)
        this.progress(0)
        this.subsciptionKOlist.innerHTML = ''
        this.noAnswer = []

        this.el.querySelector('.patrner-req').classList.remove('hidden')
        this.el.querySelector('.patrner-req').classList.add('flex')
        this.el.querySelector('.card__wrapper').classList.add('hidden')
      }, 300)
    }
  },
}
